import styled from 'styled-components'

const MenuDivider = styled.div`
  flex: 0 0 auto;
  margin: 5px 10px;
  border-top: 1px solid #ccc;
`

export default MenuDivider
